function initSwiper() {


  let swiperSectionCatalog = new Swiper('.section-catalog__swiper-container', {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: '.section-catalog__swiper-container .Swiper-button-next-video-reviews',
      prevEl: '.section-catalog__swiper-container .Swiper-button-prev-video-reviews',
    },
    pagination: {
      el: '.section-catalog__swiper-container .swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
    },
  });


	let sliderThumbs = new Swiper('.swiper-card-horizontal', {
		direction: 'horizontal',
		slidesPerView: 3,
		spaceBetween: 10,
		mousewheel: true,
		slideToClickedSlide: true,
		grab: true,
		// loop: true,
		navigation: {
			nextEl: '.slider__next-horizontal',
			prevEl: '.slider__prev-horizontal',
		},
	})

	let sliderImages = new Swiper('.swiper-card-vertical', {
		direction: 'vertical',
		slidesPerView: 3,
		spaceBetween: 10,
		mousewheel: true,
		slideToClickedSlide: true,
		grab: true,
		// loop: true,
		navigation: {
			nextEl: '.slider__next-vertical',
			prevEl: '.slider__prev-vertical',
		},

		breakpoints: {
			0: {
				direction: 'horizontal',
			},
			768: {
				direction: 'vertical',
			},
		},
	})

	let swiperVideoRevies = new Swiper(
		'.section-video-reviews__swiper-container',
		{
			slidesPerView: 2,
			spaceBetween: 10,
			loop: true,
			navigation: {
				nextEl: '.Swiper-button-next-video-reviews',
				prevEl: '.Swiper-button-prev-video-reviews',
			},
			breakpoints: {
				730: {
					slidesPerView: 3,
					spaceBetween: 10,
					slidesPerGroup: 1,
				},
				991: {
					slidesPerView: 4,
					spaceBetween: 10,
					slidesPerGroup: 1,
				},
			},
		}
	)
	var sliderSelector = '.section-advantages__swiper-container',
		options = {
			init: false,
			loop: true,
			speed: 800,
			slidesPerView: 1, // or 'auto'
			// spaceBetween: 10,
			centeredSlides: true,
			effect: 'coverflow', // 'cube', 'fade', 'coverflow',
			coverflowEffect: {
				rotate: 0, // Slide rotate in degrees
				stretch: 270, // Stretch space between slides (in px)
				depth: 100, // Depth offset in px (slides translate in Z axis)
				modifier: 1,
				slideShadows: false, // Enables slides shadows
			},
			grabCursor: true,
			parallax: true,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.section-advantages__swiper-container .Swiper-button-next',
				prevEl: '.section-advantages__swiper-container .Swiper-button-prev',
			},
			breakpoints: {
				1023: {
					slidesPerView: 2.5,
					spaceBetween: 0,
				},
			},
			// Events
			on: {
				imagesReady: function () {
					this.el.classList.remove('loading')
				},
			},
		}
	var mySwiper = new Swiper(sliderSelector, options)

	// Initialize slider
	mySwiper.init()
	let swiperPartners = new Swiper('.section-partners__swiper-container', {
		slidesPerView: 2,
		spaceBetween: 10,
		loop: true,
		navigation: {
			nextEl: '.Swiper-button-next-video-reviews',
			prevEl: '.Swiper-button-prev-video-reviews',
		},
		breakpoints: {
			730: {
				slidesPerView: 3,
				spaceBetween: 10,
				slidesPerGroup: 1,
			},
			991: {
				slidesPerView: 7,
				spaceBetween: 10,
				slidesPerGroup: 1,
			},
		},
	})

	// let swiperImgCatalog = new Swiper('.section-catalog__swiper-container', {
	// 	slidesPerView: 1,
	// 	spaceBetween: 10,
	// 	loop: true,
	// 	navigation: {
	// 		nextEl: '.Swiper-button-next-video-reviews',
	// 		prevEl: '.Swiper-button-prev-video-reviews',
	// 	},
	// 	pagination: {
	// 		el: '.swiper-pagination',
	// 		clickable: true,
	// 	},
	// 	breakpoints: {
	// 		1024: {
	// 			slidesPerView: 1,
	// 			spaceBetween: 10,
	// 		},
	// 	},
	// })
	let swiperLink = new Swiper('.Swiper-links__swiper-container', {
		slidesPerView: 'auto',
		// spaceBetween: 15,
		// preventClicks: false,
		clickable: true,
		// loop: true,
		navigation: {
			nextEl: '.Swiper-button-next',
			prevEl: '.Swiper-button-prev',
		},
		breakpoints: {
			1024: {
				// spaceBetween: 10,
			},
		},
	})
	let swiperLinkBtn = new Swiper('.Swiper-links-btn__swiper-container', {
		slidesPerView: 'auto',
		freeMode: true,
		loop: true,
		spaceBetween: 5,
		// preventClicks: false,
		clickable: true,
		// loop: true,
		navigation: {
			nextEl: '.Swiper-button-next',
			prevEl: '.Swiper-button-prev',
		},
		breakpoints: {
			1024: {
				slidesPerView: 5,
				spaceBetween: 15,
			},
		},
	})
	let swiperPopUpMaster = new Swiper(
		'.popup-selection-master__swiper-container, .popup-interior-door__swiper-container',
		{
			slidesPerView: 1,
			observer: true,
			autoHeight: true,
			simulateTouch: false,
			navigation: {
				nextEl: '.popup-swiper-btn-next-js',
				prevEl: '.popup-swiper-btn-prev-js',
			},
		}
	)
	let swiperPopUpInformation = new Swiper(
		'.popup-information__swiper-container',
		{
			slidesPerView: 1,
			observer: true,
			// autoHeight: true,
			simulateTouch: true,
			navigation: {
				nextEl: '.popup-swiper-btn-next-js',
				prevEl: '.popup-swiper-btn-prev-js',
			},
		}
	)

	let swiperImgCardElementary = new Swiper(
		'.item-Card-elementary__swiper-container',
		{
			slidesPerView: 1,
			spaceBetween: 10,
			loop: true,
			navigation: {
				nextEl: '.Swiper-button-next-video-reviews',
				prevEl: '.Swiper-button-prev-video-reviews',
			},
		}
	)

	let swiperSectionProducts = new Swiper(
		'.section-products__swiper-container',
		{
			slidesPerView: 2,
			spaceBetween: 12,
			// loop: true,
			autoHeight: true,
			observer: true,
			observeParents: true,
			simulateTouch: true,
			navigation: {
				nextEl: '.Swiper-button-next-video-reviews',
				prevEl: '.Swiper-button-prev-video-reviews',
			},
			breakpoints: {
				650: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
				800: {
					slidesPerView: 2,
					spaceBetween: 10,
				},
				1023: {
					slidesPerView: 3,
					spaceBetween: 10,
				},
				1250: {
					slidesPerView: 4,
					spaceBetween: 20,
				},
			},
		}
	)
	if (document.querySelector('.section-products__swiper-container')) {
		document
			.querySelector('.section-products__swiper-container')
			.removeAttribute('style')
		document
			.querySelector('.section-products__swiper-container > div')
			.removeAttribute('style')
	}
	let swiperSectionRelatedProducts = new Swiper(
		'.section-related-products__swiper-container',
		{
			slidesPerView: 1,
			spaceBetween: 10,
			loop: true,
			// autoHeight: true,
			observer: true,
			observeParents: true,
			simulateTouch: false,
			navigation: {
				nextEl: '.Swiper-button-next-video-reviews',
				prevEl: '.Swiper-button-prev-video-reviews',
			},
			breakpoints: {
				1250: {
					slidesPerView: 4,
					spaceBetween: 20,
				},
				850: {
					slidesPerView: 3,
					spaceBetween: 12,
				},
				550: {
					slidesPerView: 2,
					spaceBetween: 12,
				},
			},
		}
	)

	;(function discountSlider() {
		const discountSlidersThumb = document.querySelectorAll(
			'.slider__thumbs--second .swiper-container'
		)
		const discountSlidersImg = document.querySelectorAll(
			'.slider__images--second .swiper-container'
		)
		if (!discountSlidersThumb.length) return
		let swiperArr = []
		discountSlidersThumb.forEach((slider, id) => {
			console.log(slider, discountSlidersImg[id])

			if (slider && discountSlidersImg[id]) {
				swiperArr[id] = new Swiper(slider, {
					// ищем слайдер превью по селектору
					// ? задаем параметры
					direction: 'vertical', // вертикальная прокрутка
					slidesPerView: '3', // показывать по 3 превью
					spaceBetween: 10, // расстояние между слайдами
					navigation: {
						// задаем кнопки навигации
						nextEl: '.slider__next', // кнопка Next
						prevEl: '.slider__prev', // кнопка Prev
					},
					freeMode: true, // при перетаскивании превью ведет себя как при скролле
					breakpoints: {
						// условия для разных размеров окна браузера
						0: {
							// при 0px и выше
							direction: 'horizontal', // горизонтальная прокрутка
						},
						768: {
							// при 768px и выше
							direction: 'vertical', // вертикальная прокрутка
							slidesPerView: 3,
						},
					},
				})

				new Swiper(discountSlidersImg[id], {
					// ищем слайдер превью по селектору
					// задаем параметры
					direction: 'vertical', // вертикальная прокрутка
					slidesPerView: 1, // показывать по 1 изображению
					spaceBetween: 10, // расстояние между слайдами
					mousewheel: true, // можно прокручивать изображения колёсиком мыши
					navigation: {
						// задаем кнопки навигации
						nextEl: '.slider__next', // кнопка Next
						prevEl: '.slider__prev', // кнопка Prev
					},
					grabCursor: true, // менять иконку курсора
					thumbs: {
						// указываем на превью слайдер
						swiper: swiperArr[id], // указываем имя превью слайдера
					},
					breakpoints: {
						// условия для разных размеров окна браузера
						0: {
							// при 0px и выше
							direction: 'horizontal', // горизонтальная прокрутка
						},
						768: {
							// при 768px и выше
							direction: 'vertical', // вертикальная прокрутка
						},
					},
				})
			}
		})
	})()

	// ! Cлайдер с миниатюрами три в ряд
	// const sliderThumbsThree = new Swiper('.slider__thumbs--second .swiper-container', {
	// 	// ищем слайдер превью по селектору
	// 	// ? задаем параметры
	// 	direction: 'vertical', // вертикальная прокрутка
	// 	slidesPerView: '3', // показывать по 3 превью
	// 	spaceBetween: 10, // расстояние между слайдами
	// 	navigation: {
	// 		// задаем кнопки навигации
	// 		nextEl: '.slider__next', // кнопка Next
	// 		prevEl: '.slider__prev', // кнопка Prev
	// 	},
	// 	freeMode: true, // при перетаскивании превью ведет себя как при скролле
	// 	breakpoints: {
	// 		// условия для разных размеров окна браузера
	// 		0: {
	// 			// при 0px и выше
	// 			direction: 'horizontal', // горизонтальная прокрутка
	// 		},
	// 		768: {
	// 			// при 768px и выше
	// 			direction: 'vertical', // вертикальная прокрутка
	// 			slidesPerView: 3,
	// 		},
	// 	},
	// })
	// // ? Инициализация слайдера изображений
	// const sliderImagesThree = new Swiper('.slider__images--second .swiper-container', {
	// 	// ищем слайдер превью по селектору
	// 	// задаем параметры
	// 	direction: 'vertical', // вертикальная прокрутка
	// 	slidesPerView: 1, // показывать по 1 изображению
	// 	spaceBetween: 10, // расстояние между слайдами
	// 	mousewheel: true, // можно прокручивать изображения колёсиком мыши
	// 	navigation: {
	// 		// задаем кнопки навигации
	// 		nextEl: '.slider__next', // кнопка Next
	// 		prevEl: '.slider__prev', // кнопка Prev
	// 	},
	// 	grabCursor: true, // менять иконку курсора
	// 	thumbs: {
	// 		// указываем на превью слайдер
	// 		swiper: sliderThumbsThree, // указываем имя превью слайдера
	// 	},
	// 	breakpoints: {
	// 		// условия для разных размеров окна браузера
	// 		0: {
	// 			// при 0px и выше
	// 			direction: 'horizontal', // горизонтальная прокрутка
	// 		},
	// 		768: {
	// 			// при 768px и выше
	// 			direction: 'vertical', // вертикальная прокрутка
	// 		},
	// 	},
	// })

	const slides = document.querySelectorAll('.swiper-slide-horizontal')

	slides.forEach((slide, index) => {
		slide.addEventListener('click', () => {
			slides.forEach(s => {
				s.classList.remove('swiper-slide-active')
			})
			slide.classList.add('swiper-slide-active')
			slider.slideTo(index)
		})
	})

	const slidesV = document.querySelectorAll('.swiper-slide-vertical')

	slidesV.forEach((slide, index) => {
		slide.addEventListener('click', () => {
			slidesV.forEach(s => {
				s.classList.remove('swiper-slide-active')
			})
			slide.classList.add('swiper-slide-active')
			slider.slideTo(index)
		})
	})
}

function updateSwiperWidth() {
	const slides = document.querySelectorAll('.swiper-slide-horizontal')

	if (slides.length == 1) {
		const swiper = document.querySelector('.swiper-card-horizontal')
		const slide = document.querySelector(
			'.swiper-slide.swiper-slide-horizontal'
		)
		const cont = document.querySelector('.cont')

		if (slide) {
			slide.classList.add('test-1')
			slide.style.width = '100px'
		}
		if (cont) {
			cont.style.width = '121px'
		}
	}
	if (slides.length == 2) {
		const swiper = document.querySelector('.swiper-card-horizontal')
		const slides = document.querySelectorAll(
			'.swiper-slide.swiper-slide-horizontal'
		)
		const cont = document.querySelector('.cont')
		slides.forEach(slide => {
			slide.classList.add('test-2')
		})
		if (cont) {
			cont.style.width = '340px'
		}
	}
}
initSwiper();
document.addEventListener('DOMContentLoaded', updateSwiperWidth)
